'use strict';
namespace Dashboard {

    export interface IRedirectParams {
        CSRID?: string;
        NAV: string;
        SID: string;
        BID: string;
        SN: string;
        trackingTag?: string;
        categoryId?: string;
    }

    export class V1Redirection {

        constructor(private $http,
                    private $window,
                    private $location,
                    private dashboardBookingService) {
        }

        v1Redirect(routeParams: IRedirectParams): void {
            var url;
            switch (routeParams.NAV) {
                case 'contactdetails':
                    url = 'change-your-contact-details.aspx';
                    break;
                case 'cancel':
                    url = 'cancel-your-booking.aspx';
                    break;
                case 'api':
                    url = 'submit-your-passenger-information.aspx';
                    break;
                case 'printvoucher':
                    url = 'view-booking-receipt.aspx';
                    break;
                case 'payment':
                    url = 'make-a-payment.aspx';
                    break;
                case 'newrequest':
                    url = 'raise-a-customer-service-request.aspx';
                    break;
                case 'viewrequest':
                    url = 'customer-service-request-details.aspx?Id=' + routeParams.CSRID;
                    break;
                case 'amend':
                    // tslint:disable-next-line
                    url = 'amend-your-booking.aspx?';
                    if (routeParams.trackingTag) {
                        url += `trackingTag=${routeParams.trackingTag}&`;
                    }
                    if (routeParams.categoryId) {
                        url += `categoryId=${routeParams.categoryId}&`;
                    }
                    break;
                case 'review':
                    url = '/Client/clClientFeedBack.aspx?bid={0}&emailLink=0';
                    break;
                case 'options':
                    url = 'options.aspx';
                    break;
            }

            this._loadBooking(routeParams, url);

        }

        private _loadBooking(routeParams: IRedirectParams, url) {
            var mybPath = '/manage-your-booking/';
            var data = {
                bookingId: routeParams.BID,
                siteId: routeParams.SID,
                surname: routeParams.SN,
                type: (routeParams.NAV === 'review')?2:1
            };

            const loadV1 = () => {
                return this.$http.get('/Include/Handlers/UserAccount.ashx?' + $.param(data)).then((result) => {
                    if (result.data.success === true) {
                        if (data.type === 2) {
                            url = String.format(url, result.data.secureId);
                            this.$window.location = url;
                            location.replace(url);
                        } else {
                            this.$window.location = mybPath + url;
                            location.replace(mybPath + url);
                        }

                    }
                });
            };

            if (TRPCONFIG.Domain.AccountsEnabled && _.includes(['amend', 'cancel'], routeParams.NAV)) {
                return this.dashboardBookingService.getBookingDetail(routeParams.BID).then(details =>
                    details && details.PackageId
                        ? this.$location.path(`dashboard/csr/${data.bookingId}`).search({
                            id: routeParams.NAV === 'amend' ? '129' : '3'
                        })
                        : loadV1()
                );
            }

            return loadV1();
        }

    }

    angular
        .module('dashboard')
        .service('v1Redirection', V1Redirection);

}
